import type { BrandConfig } from './types';

export const kkConfig: BrandConfig = {
  brand: 'kk',
  portalTitle: 'KK Portal',
  logoTitle: 'KK Technical Services',
  loginWelcome: 'Welcome to KKTS Portal!',
  sentryProject: 'kkportal',
  sentryRelease: `kkportal@${__APP_VERSION__}`,
  // $color-brand-600 / $color-brand-800 under KKT. Kept as literals because
  // Vuetify's theme is built in TS, before any stylesheet is evaluated.
  vuetifyPrimary: '#2553eb',
  vuetifySecondary: '#1e40af',
  carouselImages: [
    new URL('@/assets/images/DJI_0012-768x576.jpg', import.meta.url).href,
    new URL('@/assets/images/DSC_9746-768x512.jpg', import.meta.url).href,
    new URL('@/assets/images/AKP_2983-768x513.jpg', import.meta.url).href,
    new URL('@/assets/images/DSC_9687-768x512.jpg', import.meta.url).href,
    new URL('@/assets/images/AKP_7229-768x513.jpg', import.meta.url).href,
  ],
};
